// Auth Actions
// import Vue from 'vue'
// import VueAuth from '@websanova/vue-auth'
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

export const setAuthUserData = ({ commit }, payload) => {
  commit('setAuthUserData', payload)
}

export const resetAuthUserData = ({ commit }) => {
  commit('resetAuthUserData')
}

export const setAuthToken = ({ commit }, payload) => {
  commit('setAuthToken', payload)
}

export const setLoginCashiersList = async ({ commit }, payload) => {
  let cashiersList = []
  try {
    const result = await Axios.get(`login_cashiers_list/${payload}`)
    result.data.data.forEach(cashier => {
      cashiersList.push({
        text: cashier.cashier_login_option,
        value: cashier.email
      })
    })
    commit('setLoginCashiersList', cashiersList)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
    // console.error('Outlet List Error:', error)
  }
}
